export default __webpack_public_path__ + "static/media/051-parents.a79e86ff.svg";